module.exports = __webpack_public_path__ + "img/purchase4.59469e4d.png";